<ng-container [appPreloader]="[endpoints.SOLE_BUSINESSES_POST, endpoints.SOLE_BUSINESSES_PUT]"
  [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<form [formGroup]="form" (ngSubmit)="submit()" appFormErrorScroll>
  <div class="row">
    <div class="col-12 col-lg-6">
      <mat-form-field>
        <mat-label>Business name</mat-label>
        <input matInput formControlName="name" maxlength="60" placeholder="Enter your business name">
        <mat-error>
          <app-validation-error [errors]="form.get('name').errors"></app-validation-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-6">
      <app-business-activity-autocomplete formControlName="activity"></app-business-activity-autocomplete>
    </div>

    <div class="col-12">
      <mat-form-field>
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" placeholder="Enter a brief description of your business">
        <mat-error>
          <app-validation-error [errors]="form.get('description').errors"></app-validation-error>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-12 col-lg-6">
      <!-- @TODO Alex: create separated form control -->
      <mat-form-field>
        <mat-label>Website</mat-label>
        <input matInput formControlName="website" placeholder="Business website (if applicable)">
        <mat-error>
          <app-validation-error [errors]="form.get('website').errors"></app-validation-error>
        </mat-error>
      </mat-form-field>
    </div>


    @if (form.contains('losses')) {
      <div class="col-12 col-lg-6" >
        <ng-container formArrayName="losses">
          <ng-container [formGroup]="form.lossFormGroup">
            <app-currency-input min="0"
              formControlName="openBalance"
              label="Prior year losses"
              pTooltip="Enter annual amount if applicable (or $0 to add later)"
              placeholder="Enter annual amount if applicable (or $0 to add later)">
            </app-currency-input>
          </ng-container>
        </ng-container>
      </div>
    }

    @if (form.contains('incomeSource')) {
      <ng-container formGroupName="incomeSource">
        <!-- @TODO Alex (TT-2304): move to separated form component -->
        <ng-container formArrayName="soleForecasts">
          <ng-container [formGroup]="form.forecastFormGroup">
            <div class="col-12 col-lg-6">
              <app-currency-input formControlName="amount"
                label="Forecasted business Profit/(Loss)"
                placeholder="Enter annual amount">
              </app-currency-input>
            </div>
            <div class="col-12 col-lg-6">
              <app-currency-input min="0"
                formControlName="taxInstalments"
                label="Forecasted tax Instalments"
                placeholder="Enter annual amount (or $0 to add later)">
              </app-currency-input>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    }

    <div class="col-12 col-lg-6 align-v-center">
      <mat-checkbox formControlName="isPrimaryProduction">This is a Primary Production Business</mat-checkbox>
    </div>

    <div class="col-12 mv-5 align-v-center">
      <mat-checkbox formControlName="isTaxFree">
        Exclude from personal tax calculations
        <i class="icon-info ic-primary"
           matTooltip="Tick this box if you’re adding a business for tracking or invoicing only (for example, a company, trust, or commercial property). It will not be included in your tax summary">
        </i>
      </mat-checkbox>
    </div>

    @if (form.value.isTaxFree) {
      <div class="col-12 col-lg-6">
        <mat-form-field>
          <mat-label>ABN</mat-label>
          <input matInput formControlName="abn" placeholder="Enter ABN">
          <mat-error>
            <app-validation-error [errors]="form.get('abn').errors"></app-validation-error>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-12 col-lg-6 align-v-center">
        <mat-checkbox formControlName="isGST">Are you registered for GST?</mat-checkbox>
      </div>

      <div class="col-12 col-lg-6">
        <app-address-input [hideRequiredMarker]="true" formControlName="address"></app-address-input>
      </div>
    }
  </div>
</form>
